export var SubscriptionBillingRecurrence;
(function (SubscriptionBillingRecurrence) {
    SubscriptionBillingRecurrence[SubscriptionBillingRecurrence["NonRecurring"] = 0] = "NonRecurring";
    SubscriptionBillingRecurrence[SubscriptionBillingRecurrence["Recurring"] = 1] = "Recurring";
})(SubscriptionBillingRecurrence || (SubscriptionBillingRecurrence = {}));
export const getBillingRecurrence = (isRecurring) => {
    return isRecurring ? SubscriptionBillingRecurrence.Recurring : SubscriptionBillingRecurrence.NonRecurring;
};
